import authApi from '@/api/system/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { ACCOUNT_MAP } from '@/config/index.js';
import { Message } from 'element-ui'
const user = {
	state: {
		id : null,
		userData : {},
		name : '',
		role_type : '',
		logo : '',
		account_map : {},
		menus: [],
		routers:[],
		token: getToken()
	},
	getters: {
		hasUserInfo:state=>{
  			return state.id != null
		},
		token:state => {
			return state.token
		}
	},
	mutations: {
		SET_USER( state, data ) {
			state.userData = data
		},
		SET_USERID( state,id ) {
			state.id = id
		},
		SET_NAME( state, name ) {
			state.name = name
		},
		SET_ROLE_TYPE( state, role_type ) {
			state.role_type = role_type
		},
		SET_SYSTEM_NAME( state, title ) {
			state.title = title
		},
		SET_SYSTEM_LOGO( state, logo ) {
			state.logo = logo
		},
		SET_ACCOUNT_MAP(state, account_map) {
			state.account_map = account_map
		},
		SET_MENUS( state, menus) {
			state.menus = menus
		},
		SET_ROUTERS( state, routers) {
			state.routers = routers
		},
		SET_TOKEN: (state, token) => {
			state.token = token
		}
	},
	actions: {
		login({ commit },user) {
			console.log('xxx')
			return new Promise(( resolve, reject )=>{
				authApi.login(user.username,user.password, 1).then( res => {
					if (res.data.code === 1000) {
						commit('SET_TOKEN', res.data.data.accessToken)
						// console.log('ACCOUNT_MAP', ACCOUNT_MAP)
						// console.log('project', res.data.data.project)
						const {longitude, latitude, region_name, project_name} = res.data.data.project
						if(longitude&&latitude){
							const mapData = {
								address: region_name||project_name,
								center: [longitude, latitude]
							}
							localStorage.setItem('mapData', JSON.stringify(mapData))
							commit('SET_ACCOUNT_MAP', mapData)
							
						}else{
							localStorage.setItem('mapData', JSON.stringify(ACCOUNT_MAP))
							commit('SET_ACCOUNT_MAP', ACCOUNT_MAP)
						}
						setToken(res.data.data.accessToken)
						resolve(res.data)
					} else {
						resolve(res.data)
					}
				}).catch(error=>reject(error))
			})
		},
		getUserInfo({ commit,dispatch }) {
			return new Promise(( resolve, reject )=>{
				authApi.getUserInfo().then( res => {
					if (res.data.code === 1000) {
						const userInfo = res.data.data
						commit('SET_USER', userInfo)
						commit('SET_USERID',userInfo.user.id)
						commit('SET_NAME', userInfo.user.username)
						commit('SET_ROLE_TYPE', userInfo.user.role_type) // 1.超管 2.公司 3.子账号
						commit('SET_SYSTEM_NAME', userInfo.company.title)
						commit('SET_SYSTEM_LOGO', userInfo.company.logo)
						commit('SET_MENUS', userInfo.menu)
						resolve(res.data)
					} else {
						Message({
							message: res.data.message || '错误',
							type: 'error',
							duration: 3 * 1000
						})
					}
				}).catch(error=>{
					dispatch('logout')
					reject(error)
				})
			})
		},
		logout({ commit }) {
			removeToken() // must remove  token  first
			window.location.reload()
		},
		
		setMenus({ commit }, menus) {
			commit('SET_MENUS', menus)
		},
		setRouters({ commit }, routers) {
			commit('SET_ROUTERS', routers)
		},
		hasPath({ state,commit }, path) {
			return state.menus.some((item,index)=>{
				if(item.path==path){
					// console.log('hehe')
					return true
				}else{					
					return false
				}
			})
		}
	}
}
export default user
